import React from "react";
import styles from "../styles/ContactSection.module.css";

const isPrerender =
  typeof navigator !== "undefined" &&
  navigator.userAgent === "ReactSnap";

export default function ContactSection() {
  return (
    <section className={styles.section} id="contact">
      <div className={styles.container}>
        
        <div className={styles.info}>
          <span>Contact</span>

          <h2>Visit Fegaropetra</h2>

          <h1>
            Located in Garitsa Corfu, Fegaropetra offers authentic Mediterranean
            seafood that leaves an unforgettable taste.
          </h1>

          <div className={styles.details}>
            <div>
              <h4>Address</h4>
              <p>Alkiviadou Dari 99, Corfu Greece</p>
            </div>

            <div>
              <h4>Phone</h4>
              <p>+30 2261 043383</p>
            </div>

            <div>
              <h4>Email</h4>
              <p>feggaropetraseafood@gmail.com</p>
            </div>
          </div>
        </div>

        <div className={styles.map}>
          {isPrerender ? (
            <a
              href="https://maps.google.com/?q=Fegaropetra+Seafood+Corfu"
              target="_blank"
              rel="noreferrer"
            >
              View on Google Maps
            </a>
          ) : (
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3073.7382026942273!2d19.92212329155947!3d39.61057953104139!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x135b5f3d74cbf31b%3A0xfde239df83172a0c!2zRmVnYXJvcGV0cmEgU2VhZm9vZCAtIM6ozrHPgc6_z4TOsc6yzq3Pgc69zrE!5e0!3m2!1sen!2s!4v1778577026784!5m2!1sen!2s"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Fegaropetra Location"
            />
          )}
        </div>
      </div>
    </section>
  );
}